<template>
  <div class="coderesume column__center__center">
    <div class="window">
      <div class="controls row p-12 g-8">
        <div class="control close"></div>
        <div class="control minimize"></div>
        <div class="control maximize"></div>
      </div>
      <div class="code text1 p-8">
        <span class="keyword">let</span> <span class="var">name</span> =
        <span class="string">"Adriano Vieira"</span>
        <br /><br />
        <span class="keyword">let</span> <span class="var">email</span> =
        <span class="string">"adrianoj@icloud.com"</span>
        <br /><br />
        <span class="keyword">var</span> <span class="var">roles</span> = [<span class="string">"iOS Developer"</span>,
        <span class="string">"Frontend Developer"</span>] <br /><br />
        <span class="keyword">var</span> <span class="var">skills</span> = [<span class="string">"Swift"</span>,
        <span class="string">"SwiftUI"</span>, <span class="string">"Python"</span>, <span class="string">"Vue"</span>,
        <span class="string">"HTML"</span>, <span class="string">"CSS"</span>, <span class="string">"JS"</span>,
        <span class="string">"GraphQL"</span>, <span class="string">"git"</span>] <br /><br />
        <span class="keyword">var</span> <span class="var">tags</span> = [<span class="string">"#ios"</span>,
        <span class="string">"#mobile"</span>, <span class="string">"#frontend"</span>,
        <span class="string">"#design"</span>, <span class="string">"#ui/ux"</span>,
        <span class="string">"#security"</span>]
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CodeResume',
}
</script>

<style lang="scss" scoped>
.coderesume {
  height: 600px;

  .window {
    width: 640px;
    height: 400px;
    background-color: #343d46;
    border-radius: 12px;
    box-shadow: 4px 4px 10px 4px rgba(0, 0, 0, 0.1);

    @media (max-width: 800px) {
      width: 80vw;
    }

    .controls {
      .control {
        width: 12px;
        height: 12px;
        border-radius: 50%;

        &.close {
          background-color: #df6158;
        }

        &.minimize {
          background-color: #eebc3c;
        }

        &.maximize {
          background-color: #7aca4f;
        }
      }
    }

    .code {
      .keyword {
        color: #f2a;
      }
      .var {
        color: #6ef;
      }
      .string {
        color: #f44;
      }

      @media (max-width: 800px) {
        font-size: 1rem;
      }
    }
  }
}
</style>
